export default __webpack_public_path__ + "static/media/white cap.1609eddd.jpeg";